import { render, staticRenderFns } from "./linkedvideo.vue?vue&type=template&id=35bf5261"
import script from "./linkedvideo.vue?vue&type=script&lang=ts"
export * from "./linkedvideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports